module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/wilfred-7849e05aaba139e502ed4bb94a2fac3f.jpg";